import Tooltip from './tooltip';
export let _Vue;

Tooltip.install = function(Vue) {
  _Vue = Vue;
  Vue.component(Tooltip.name, Tooltip);
};

export default Tooltip;
